import { useTranslation } from "react-i18next";
import { changeLocale, type Locale } from "../../i18n";

interface LangSwitchProps {
  /** Green login panel styling (Mini portal). */
  variant?: "default" | "login";
}

export function LangSwitch({ variant = "default" }: LangSwitchProps) {
  const { i18n } = useTranslation();
  const current = i18n.language as Locale;
  const isLogin = variant === "login";

  return (
    <div
      className={
        isLogin
          ? "mb-4 flex justify-center gap-1 rounded-lg border border-godo-input-border bg-godo-input-bg p-0.5"
          : "flex gap-1 rounded-lg border border-slate-200 bg-slate-50 p-0.5"
      }
    >
      {(["ar", "en"] as const).map((locale) => (
        <button
          key={locale}
          type="button"
          onClick={() => changeLocale(locale)}
          className={`rounded-md px-2 py-1 text-xs font-medium transition ${
            current === locale
              ? isLogin
                ? "bg-godo-accent text-white shadow-sm"
                : "bg-white text-godo-primary shadow-sm"
              : isLogin
                ? "text-godo-mint hover:text-godo-primary"
                : "text-slate-500 hover:text-slate-700"
          }`}
        >
          {locale === "ar"
            ? i18n.t("labels.lang_switch_ar")
            : i18n.t("labels.lang_switch_en")}
        </button>
      ))}
    </div>
  );
}
